import React, { useState } from 'react';
import Tabs from '../components/Tabs';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { tabs } from '../config.js';

const Protocol = () => {
  const protocolTabs = tabs.filter(tab => tab.page === 'protocol')
  const firstProtocolTabId = protocolTabs.find(tab => tab.page === 'protocol').id;
  
  const [activeTab, setActiveTab] = useState(firstProtocolTabId);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
      <div className="flex rounded-xl justify-center h-full my-2 mx-6">
        {protocolTabs.length === 1 ? null : 
            <div className="flex flex-col bg-transparent pr-3">
              <Tabs tabs={protocolTabs} activeTab={activeTab} onTabChange={handleTabChange} iconClasses="h-[24px] w-[24px]" />
            </div>
          }
          <div className="bg-white flex w-full h-full rounded-lg justify-center items-center p-2">
            {protocolTabs.map((tab) => (
              activeTab === tab.id && (
                <iframe
                  key={tab.id}
                  src={tab.src}
                  title={tab.label}
                  className="w-full h-full border rounded-lg"
                  frameBorder="0"
                />
              )
            ))}
          </div>
          <ReactTooltip
          id="protocol-tooltip"
          place="right"
          content="Protocol"
          />
      </div>
  );
};

export default Protocol;
